import React from 'react';
import Home from './components/Home.jsx';
import Career from './components/Career.jsx';
import Projects from './components/Projects.jsx';
import Contact from './components/Contact.jsx';
import About from './components/About.jsx';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useEffect } from 'react';
import AS from './images/AS.png'
import Starfield from './components/starfield.tsx';

function App() {

  useEffect(() => {
    document.title = 'Avneet Singh — AI/ML Engineer';
    const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
  link.type = 'image/png';
  link.rel = 'icon';
  link.href = AS;
  document.getElementsByTagName('head')[0].appendChild(link);
  }, []);  

  return (
    <Router>
      <div className="App">
      <Starfield
          starCount={500}
          starColor={[255, 255, 255]}
          speedFactor={0.05}
          backgroundColor="black"
        />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/career" element={<Career />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
